import { computed, ref } from 'vue';
import { useAuthStore } from '@/domains/auth';
import { useServiceTypesStore } from '../stores/serviceTypes.store';
import { serviceFormLookupsRepository, } from '../repositories/service-form-lookups.repository';
export function useServiceFormLookups(options = {}) {
    const authStore = useAuthStore();
    const repository = options.repository ?? serviceFormLookupsRepository;
    const serviceTypesStore = options.serviceTypesStore ?? useServiceTypesStore();
    const categories = ref([]);
    const providers = ref([]);
    const categoryError = ref('');
    const isLoadingCategories = ref(false);
    const isLoadingProviders = ref(false);
    const serviceTypes = computed(() => serviceTypesStore.serviceTypes);
    async function loadCategories(selectedCategoryId) {
        if (!authStore.currentOrgId) {
            categories.value = [];
            categoryError.value = 'Seleccione una organización proveedora para cargar categorías.';
            return null;
        }
        isLoadingCategories.value = true;
        categoryError.value = '';
        try {
            categories.value = await repository.getAssignableCategories();
            if (selectedCategoryId != null &&
                !categories.value.some((category) => Number(category.id) === Number(selectedCategoryId))) {
                return null;
            }
            return selectedCategoryId;
        }
        catch (error) {
            console.error('Error loading categories:', error);
            categories.value = [];
            categoryError.value = 'No se pudieron cargar las categorías para la organización seleccionada.';
            return null;
        }
        finally {
            isLoadingCategories.value = false;
        }
    }
    async function loadProviders() {
        isLoadingProviders.value = true;
        try {
            providers.value = await repository.getProviders();
            return providers.value;
        }
        catch (error) {
            console.error('Error loading providers:', error);
            providers.value = [];
            return [];
        }
        finally {
            isLoadingProviders.value = false;
        }
    }
    async function loadServiceTypes() {
        await serviceTypesStore.fetchAll();
        return serviceTypesStore.serviceTypes;
    }
    async function loadAll(selectedCategoryId) {
        const [categoryId] = await Promise.all([
            loadCategories(selectedCategoryId),
            loadProviders(),
            loadServiceTypes(),
        ]);
        return { categoryId, providers: providers.value, serviceTypes: serviceTypesStore.serviceTypes };
    }
    function selectProviderForUser(currentProviderId, isAdmin) {
        const providerId = Number(currentProviderId) || 0;
        if (isAdmin || providerId > 0) {
            return providerId;
        }
        return providers.value.length === 1 ? providers.value[0].id : 0;
    }
    return {
        categories,
        providers,
        serviceTypes,
        categoryError,
        isLoadingCategories,
        isLoadingProviders,
        loadCategories,
        loadProviders,
        loadServiceTypes,
        loadAll,
        selectProviderForUser,
    };
}
